<template>
    <div class="request-container">
        <!-- Provider Search -->
        <div class="section">
            <div class="main">
                <label class="label">{{ $t('modals.patient_profile.profile.request.search') }}</label>
                <span class="verified">{{ $t('modals.patient_profile.profile.request.verify') }}</span>
            </div>
            <div class="filter-bar">
                <input type="text" class="search-input" :placeholder="$t('forms.patient_profile.fields.search.placeholder')" />
                <common-icon name="search" size="small" @click="viewDocument(doc)"></common-icon>
            </div>
        </div>

        <!-- Records Needed -->
        <div class="section">
            <h3 class="hipa-title">{{ $t('modals.patient_profile.profile.request.record') }}</h3>
            <div class="checkbox-group">
                <label>
                    <input type="checkbox" />
                    <p>{{ $t('modals.patient_profile.profile.request.list_one') }}</p>
                </label>
                <label>
                    <input type="checkbox" />
                    <p>{{ $t('modals.patient_profile.profile.request.list_two') }}</p>
                </label>
                <label>
                    <input type="checkbox" />
                    <p>{{ $t('modals.patient_profile.profile.request.list_three') }}</p>
                </label>
                <label>
                    <input type="checkbox" />
                    <p>{{ $t('modals.patient_profile.profile.request.list_four') }}</p>
                </label>
                <label>
                    <input type="checkbox" />
                    <p>{{ $t('modals.patient_profile.profile.request.list_five') }}</p>
                </label>
                <label>
                    <input type="checkbox" />
                    <p>{{ $t('modals.patient_profile.profile.request.list_six') }}</p>
                </label>
                <label>
                    <input type="checkbox" />
                    <p>{{ $t('modals.patient_profile.profile.request.list_seven') }}</p>
                </label>
                <label>
                    <input type="checkbox" />
                    <p>{{ $t('modals.patient_profile.profile.request.list_eight') }}</p>
                </label>
            </div>
        </div>
        <form-wrapper class="practice-information-form">
            <form-row>
                <form-cell width="full">
                    <label class="form-field__label">
                        {{ $t('forms.patient_profile.fields.hipaa.authorization.label') }}
                    </label>
                    <select-input
                        class="schedule-apply__input"
                        :placeholder="$t('forms.patient_profile.fields.hipaa.authorization.placeholder')"
                        :hasAutofocus="true"
                        :options="locationOptions"
                        @change="changeCurrentLocationId($event)"
                    ></select-input>
                </form-cell>
            </form-row>
            <h3 class="hipa-titles">{{ $t('modals.patient_profile.profile.request.range') }}</h3>
            <form-row>
                <form-cell width="half">
                    <label class="form-field__label">
                        {{ $t('forms.patient_profile.fields.date_range.label') }}
                    </label>
                    <text-field
                        class=""
                        :placeholder="$t('forms.patient_profile.fields.date_range.insurance_plans.placeholder')"
                        :isRequired="false"
                        :formData="data"
                        valuePath="memberId"
                        type="date"
                    ></text-field>
                </form-cell>
                <form-cell width="half">
                    <label class="form-field__label">
                        {{ $t('forms.patient_profile.fields.date_range.document.label') }}
                    </label>
                    <text-field
                        class=""
                        :placeholder="$t('forms.patient_profile.fields.date_range.document.placeholder')"
                        :isRequired="false"
                        :formData="data"
                        valuePath="memberId"
                        type="date"
                    ></text-field>
                </form-cell>
            </form-row>
            <form-row>
                <form-cell width="full">
                    <label class="form-field__label">
                        {{ $t('forms.patient_profile.fields.date_range.provider.label') }}
                    </label>
                    <select-input
                        class="schedule-apply__input"
                        :placeholder="$t('forms.patient_profile.fields.date_range.provider.placeholder')"
                        :hasAutofocus="true"
                        :options="requestnOption"
                        @change="changeCurrentLocationId($event)"
                    ></select-input>
                </form-cell>
            </form-row>
            <form-row>
                <form-cell width="full">
                    <textarea-field
                        :label="$t('forms.patient_profile.fields.profile.additional.label')"
                        :placeholder="$t('forms.patient_profile.fields.profile.additional.placeholder')"
                        :isRequired="true"
                        :formData="data"
                        valuePath="message"
                        @change="change($event)"
                    ></textarea-field>
                </form-cell>
            </form-row>
        </form-wrapper>
        <div class="submit">
            <button class="request">
                <common-icon name="send" size="small"></common-icon>
                {{ $t('forms.patient_profile.fields.date_range.button.label') }}
            </button>
        </div>
    </div>
</template>
<script>
    import FormMixin from 'mixins/FormMixin'
    import HandleRequestMixin from 'mixins/HandleRequestMixin'

    export default {
        name: 'request-records-form',
        mixins: [FormMixin, HandleRequestMixin],
        data() {
            return {
                selectedDocument: null,
                locationOptions: [{ label: 'General HIPAA Authorization (expires 15/01/2026)', value: 1 }],
                requestnOption: [
                    { label: 'Continuing Care', value: 1 },
                    { label: 'Specialist Referral', value: 2 },
                    { label: 'Second Opinion', value: 3 },
                    { label: 'Personal Records', value: 4 },
                    { label: 'Insurance Claim', value: 5 },
                    { label: 'Legal Proceeding', value: 6 },
                ],
            }
        },
    }
</script>
<style scoped>
    .submit {
        margin-top: 20px;
    }

    .request {
        background-color: oklch(0.546 0.245 262.881);
        border-radius: 8px;
        color: #fff;
        padding: 8px;
        opacity: 0.5;
        margin: 10px 0px;
    }

    .filter-bar {
        display: flex;
        gap: 10px;
        position: relative;
        width: 100%;
    }

    .search-input {
        flex: 1;
        padding: 8px 29px;
        border-radius: 6px;
        border: 1px solid #f5f5f5;
        font-size: 12px;
        background-color: #f5f5f5;
        height: 51px;
    }

    .hipa-title {
        font-size: 12px;
        font-weight: 500;
        color: oklch(0.145 0 0);
        margin: 10px 0px;
    }

    .hipa-titles {
        font-size: 12px;
        font-weight: 500;
        color: oklch(0.145 0 0);
        margin: 18px 0px 0px;
    }

    .section {
        margin-bottom: 20px;
    }

    .label {
        font-weight: 500;
        display: block;
        margin-bottom: 8px;
        color: oklch(0.145 0 0);
        font-size: 16px;
    }

    .checkbox-group {
        display: grid;
        grid-template-columns: repeat(4, 1fr);
        gap: 8px 20px;
        font-size: 14px;
        align-items: center;
    }

    .checkbox-group label {
        display: flex;
    }

    .checkbox-group label p {
        margin-left: 10px;
        color: oklch(0.145 0 0);
        font-size: 13px;
        font-weight: 500;
    }

    .main {
        display: flex;
        align-items: center;
        justify-content: space-between;
        width: 100%;
        margin-bottom: 12px;
    }

    .verified {
        display: inline-block;
        background: #e6f7ec;
        color: #2e8b57;
        font-size: 12px;
        padding: 3px 8px;
        border-radius: 12px;
        margin-top: 6px;
    }
    .filter-bar i {
        position: absolute;
        top: 15px;
        left: 7px;
    }
    @media screen and (max-width: 600px) {
        .checkbox-group {
            grid-template-columns: repeat(2, 1fr);
        }

        .label {
            width: 158px;
        }
    }
</style>
